// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"efde3989","903":"a3a2fe14"}[chunkId] + ".chunk.css";
};